import { gql } from '@apollo/client';
import { CLIENT_FIELDS } from '../../fragments';
import { CreateClientProps, UpdateClientProps } from './client.types';
import { ClientType } from '../../../types';
import { GET_CLIENTS, GET_CLIENT_BY_ID } from '../../queries';

export const CREATE_CLIENT = gql`
  ${CLIENT_FIELDS}
  mutation createClient(
  $email: String!, 
  $name: String!,
  $phone1: String!,
  $phone2: String,
  $addressLine1: String,
  $addressLine2: String,
  $city: String,
  $province: String,
  $country: String,
  ) {
    createClient(
    email: $email, 
    name: $name,
    phone1: $phone1,
    phone2: $phone2,
    addressLine1: $addressLine1,
    addressLine2: $addressLine2,
    city: $city,
    province: $province,
    country: $country,
    ) {
      ...ClientFields
    }
  }
`;

export function createClient({
  client,
  email,
  name,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  province,
  country,
}: CreateClientProps) {
  return client?.mutate<{ createClient: ClientType }>({
    mutation: CREATE_CLIENT,
    variables: {
      email,
      name,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      province,
      country,
    },
    refetchQueries: [
      GET_CLIENTS,
    ],
  });
}

export const UPDATE_CLIENT = gql`
  ${CLIENT_FIELDS}
  mutation UpdateClient(
    $clientId: ID!,
    $addressLine1: String,
    $addressLine2: String,
    $billingId: ID,
    $city: String,
    $country: String,
    $email: String,
    $name: String!,
    $phone1: String,
    $phone2: String,
    $postalCode: String,
    $province: String,
  ) {
    updateClient(
      clientId: $clientId,
      addressLine1: $addressLine1,
      addressLine2: $addressLine2,
      billingId: $billingId,
      city: $city,
      country: $country,
      email: $email,
      name: $name,
      phone1: $phone1,
      phone2: $phone2,
      postalCode: $postalCode,
      province: $province,
    ) {
      ...ClientFields
    }
  }
`;

export function updateClient({
  client,
  email,
  name,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  province,
  country,
}: UpdateClientProps) {
  return client?.mutate<{ createClient: ClientType }>({
    mutation: UPDATE_CLIENT,
    variables: {
      email,
      name,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      province,
      country,
    },
    refetchQueries: [
      GET_CLIENTS,
      GET_CLIENT_BY_ID,
    ],
  });
}
